import { render, staticRenderFns } from "./PhotoUploader.vue?vue&type=template&id=4855ad8f&scoped=true"
import script from "./PhotoUploader.vue?vue&type=script&lang=ts"
export * from "./PhotoUploader.vue?vue&type=script&lang=ts"
import style0 from "./PhotoUploader.vue?vue&type=style&index=0&id=4855ad8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855ad8f",
  null
  
)

export default component.exports